import { styled, Typography } from '@nextiva/next-ui-components';

const PaymentTabContainer = styled('div')({});

const SummaryTabContainer = styled('div')({
  width: '9.125rem',
  h4: {
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
});

const baseTabTextStyles = {
  fontWeight: '900',
  letterSpacing: '0.25px',
  margin: 0,
  padding: 0,
  fontFamily: 'lato, Helvetica, Arial, Verdana, Tahoma, sans-serif',
};

const StyledPaymentTabText = styled(Typography)({
  ...baseTabTextStyles,
  fontSize: '1.125rem',
  lineHeight: '1.625rem',
});

const StyledSummaryTabText = styled(Typography)({
  '&.MuiTypography-root': {
    ...baseTabTextStyles,
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
});

export {
  PaymentTabContainer,
  StyledPaymentTabText,
  StyledSummaryTabText,
  SummaryTabContainer,
};
